<template lang="pug">
modal(:active="active" :title="title" @close="close")
  div(slot="modal-body")
    div(v-if='anexo && anexo.file_info')
      .columns.my-2.p-2.align-center.item.s-rounded(:class="{destroy: anexo._destroy, added: !anexo.id}")
        .column.col-auto
          img.img-responsive.image(:src="anexo.file_info.thumb")
        .column
          div {{ anexo.file_info.name }}
          .text-gray {{ anexo.file_info.size / 1000 }}kb
          div(v-if="anexo._destroy") #[cite.text-error Este anexo será removido após a edição]
          div(v-else-if="!anexo.id") #[cite.text-success Este anexo será adicionado após a edição]
        .column.col-auto
          a.btn.btn-error.btn-action.tooltip.tooltip-left(
            v-if="!anexo._destroy"
            @click="removeAnexo()"
            data-tooltip="Remover"
          )
            i.fa.fa-trash
    upload-anexo(v-model='anexo')
  div(slot='modal-footer')
    .columns
      .column
      .column.col-auto
        a.btn.btn-primary(@click='save()')
          btn-content(name='save')
</template>

<script>
import Anexo from '@/models/Anexo'
import UploadAnexo from './UploadAnexo'

export default {
  components: { UploadAnexo },
  data() {
    return {
      active: false,
      anexo: null,
    }
  },
  props: ['title'],
  methods: {
    open(anexo = null) {
      this.active = true
      this.anexo = anexo ? new Anexo(anexo) : null
    },
    removeAnexo() {
      this.anexo = null
    },
    close() {
      this.active = false
    },
    save() {
      this.$emit('saveAnexo', this.anexo)
      this.close()
    },
  },
}
</script>

<style lang="stylus" scoped>
.image
  max-width 100px

.item
  border-bottom 1px solid #eee

.destroy
  background-color #ffece0

.added
  background-color #ebf3e8
</style>
